import axios from "axios";
import { SETTINGS } from "../../Settings";

export const AuditEventLogsRepository = {
  getAll: (page, size, searchParams, orderBy, orderDirection) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/auditEvents/search`,
      method: "POST",
      params: {
        page: page,
        size: size,
        order: `${orderBy},${orderDirection}`,
      },
      data: searchParams,
    });
  },
};
